import Column from '@components/Column';
import CustomBarcode from '@components/CustomBarcode';
import Text from '@components/Text';
import styled from '@emotion/styled';

function UseInfo() {
    return (
        <Container fullWidth align='center'>
            <Barcode spacing={4}
                align='center' >
                <CustomBarcode value='1234 5678 9012 3456' />
                <Text>1234 5678 9012 3456</Text>
            </Barcode>
        </Container>
    );
}

const Container = styled(Column)`
    padding-bottom: 32px;
`;

const Barcode = styled(Column)`
    padding: 0 40px;
`;

export default UseInfo;
